<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="m22.7 15.7-.9-.9c-.9-.9-2.1-1.2-3.2-1V8.6c0-.4.1-1.5-.7-2.5-.6-.7-1.5-1.1-2.8-1.1h-2.3c-.5-2.3-2.6-4-5-4C5 1 2.7 3.3 2.7 6.2s2.3 5.1 5.1 5.1c2.5 0 4.6-1.8 5-4.2h2.3c.4 0 1 .1 1.3.4.3.4.2.9.2.9v6.4l-.1.1c-.4.4-1 .4-1.4 0l-1.2-1.2c-1.1-1.1-2.9-1.1-4 0l-.9.8c-.4.4-1.1.4-1.6 0l-.8-.8c-1-1.1-2.9-1-3.9 0l-1.5 1.5c-.4.4-.4 1 0 1.4s1 .4 1.4 0l1.5-1.5c.3-.3.8-.3 1.1 0l.8.8c1.2 1.2 3.2 1.2 4.4 0l.9-.9c.3-.3.8-.3 1.1 0l1.2 1.2c1.2 1.2 3 1.2 4.2 0 .7-.7 1.8-.7 2.5 0l.9.9c.2.2.5.3.7.3s.5-.1.7-.3c.5-.4.5-1 .1-1.4zM7.8 9.3c-1.7 0-3.1-1.4-3.1-3.1S6.1 3 7.8 3s3.1 1.4 3.1 3.1-1.4 3.2-3.1 3.2zm12.5 10.4c-1-1-2.6-1-3.6 0l-1 1c-.4.4-1.2.4-1.6 0l-1-1c-.5-.5-1.1-.7-1.8-.7s-1.3.3-1.8.7l-.7.7c-.4.4-1 .4-1.4 0l-1.2-1.2c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L6 21.8c1.2 1.2 3 1.2 4.2 0l.7-.7c.1-.1.2-.2.4-.2.1 0 .3.1.4.2l1 1c.6.6 1.4.9 2.2.9.8 0 1.6-.3 2.2-.9l1-1c.2-.2.6-.2.8 0l.7.7c.4.4 1 .4 1.4 0s.4-1 0-1.4l-.7-.7z"
        data-follow-fill="currentColor"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
